import React from 'react';
import dateFormat, { masks } from "dateformat";
class CustomerMasterDetailView extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return ( 
    <div>
      <p className='col1'>CRM CODE:&nbsp;&nbsp;&nbsp;{this.props.data.data.CRM_CUSCODE}</p>
      <p className='col1'>SMF CODE:&nbsp;&nbsp;&nbsp;{this.props.data.data.SMF_CUSCODE}</p>
      <p className='col1'>Customer name:</p><p className='col2'>{this.props.data.data.CUSTOMER_NAME}</p>
      <p className='col1'>TAX ID:</p><p className='col2'>{this.props.data.data.TAX_ID}</p>
      <p className='col1'>Stage:</p><p className='col2'>{this.props.data.data.CUSTOMER_STATUS_EN}/{this.props.data.data.CUSTOMER_STATUS_TH}</p>
      <p className='col1'>Type:</p><p className='col2'>{this.props.data.data.CUSTOMER_TYPE_EN}</p>
      <p className='col1'>Tier:</p><p className='col2'>{this.props.data.data.GLOBAL_TIER_EN}</p>

      <p className='col1'>Email:</p><p className='col2'>{this.props.data.data.CUSTOMER_EMAIL}</p>
      <p className='col1'>Phone:</p><p className='col2'>{this.props.data.data.CUSTOMER_PHONE}</p>
      <p className='col1'>Address:</p><p className='col2'>{this.props.data.data.CUSTOMER_ADDRESS}</p>
      <p className='col1'>Province:</p><p className='col2'>{this.props.data.data.CUSTOMER_PROVINCE}</p>
     
      <p className='col1'>CREATE DATE:</p><p className='col2'>{dateFormat(this.props.data.data.CREATE_DATE,"dd-mmm-yyyy")}</p>
      </div>
    );
  }
}

export default CustomerMasterDetailView;
